<template>
    <nav class="navbar navbar-expand-lg navbar-dark bg-dark">
        <div class="container-fluid">
            <button class="navbar-toggler" type="button" data-bs-toggle="collapse"
                data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false"
                aria-label="Toggle navigation">
                <span class="navbar-toggler-icon"></span>
            </button>
            <div class="collapse navbar-collapse" id="navbarSupportedContent">
                <ul class="navbar-nav me-auto mb-2 mb-lg-0">
                    <li class="nav-item dropdown" v-for="(item, index) in menuItems" :key="index">
                        <router-link :to="item.to ?? '#'" class="nav-link dropdown-toggle"
                            :id="`navbar-dropdown-masterps-${index}`" role="button" data-bs-toggle="dropdown"
                            aria-expanded="false">
                            {{ item.title }}
                        </router-link>
                        <ul class="dropdown-menu" v-if="item.children && item.children.length > 0"
                            :aria-labelledby="`navbar-dropdown-masterps-${index}`">
                            <li class="nav-item" v-for="(child, childIndex) in item.children" :key="childIndex">
                                <router-link :to="child.to" class="dropdown-item"><i :class="child.icon"></i>
                                    {{ child.title }}</router-link>
                            </li>
                        </ul>
                    </li>
                </ul>
            </div>
        </div>
    </nav>
</template>

<script>
import { menuItems } from '@/config/navigation';
import UserDropDown from '../global/UserDropDown.vue';


export default {
    components: {
        UserDropDown
    },
    data() {
        return {
            menuItems
        }
    }
}
</script>
